import LoadingScreen from 'components/LoadingScreen';
import useAuth from 'hooks/useAuth';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'redux/store';
import { getApplications } from 'redux/slices/admin/applications';
import { useParams } from 'react-router';
import { Navigate } from 'react-router-dom';
import { userHasApplicationAccess } from 'utils/applicationScope';
import { PATH_APP } from 'routes/paths';
import { isMobeatStaff } from 'utils/mobeatStaff';

export default function ApplicationGuard({ children }) {
  const { user } = useAuth();
  const { appId } = useParams();
  const dispatch = useDispatch();
  const { applicationList, isLoading } = useSelector((state) => state.applications);

  const customerId = user?.customerId;
  const numericAppId = Number(appId);
  const validRouteAppId = Number.isFinite(numericAppId);

  useEffect(() => {
    if (customerId) {
      dispatch(getApplications(customerId));
    }
  }, [dispatch, customerId]);

  if (isMobeatStaff(user?.organizationRole)) {
    return <Navigate to={PATH_APP.admin.demoLeads} replace />;
  }

  if (!user || !customerId) {
    return <Navigate to='/403' replace />;
  }

  if (!validRouteAppId) {
    return <Navigate to='/403' replace />;
  }

  if (isLoading && applicationList.length === 0) {
    return (
      <LoadingScreen
        sx={{
          top: 0,
          left: 0,
          width: 1,
          zIndex: 9999,
          position: 'fixed',
        }}
      />
    );
  }

  const ownsApp = applicationList.some((app) => app.id === numericAppId);

  if (!ownsApp) {
    return <Navigate to='/403' replace />;
  }

  if (!userHasApplicationAccess(user, numericAppId)) {
    return <Navigate to='/403' replace />;
  }

  return children;
}
